import type { AiProviderStatus } from '../ai-platform/role-config.js';

export function providerCredentialStatusLabel(provider: AiProviderStatus): string {
  if (provider.source === 'encrypted') {
    return provider.configured
      ? 'Сохранён в защищённом хранилище'
      : 'Сохранённый ключ недоступен (проверьте keyring)';
  }
  if (provider.source === 'env') {
    return 'Настроен в окружении';
  }
  return 'Ключ не задан';
}

export type ProviderCredentialBadgeKind = 'success' | 'warning' | 'muted';

export function providerCredentialBadgeKind(provider: AiProviderStatus): ProviderCredentialBadgeKind {
  if (provider.configured) return 'success';
  if (provider.source === 'encrypted') return 'warning';
  return 'muted';
}

export function providerCredentialBadgeLabel(provider: AiProviderStatus): string {
  if (provider.configured) {
    return provider.source === 'env' ? 'Из окружения' : 'Активен';
  }
  if (provider.source === 'encrypted') return 'Ключ недоступен';
  return 'Ключ не задан';
}

/** Маска для строки ключа в списке провайдеров (как в BeClients admin). */
export function maskApiKeyPreview(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '—';
  if (trimmed.length <= 8) return '••••••••';
  return `${trimmed.slice(0, 4)}••••${trimmed.slice(-4)}`;
}

export function providerCapabilityLabel(capability: 'text' | 'stt'): string {
  return capability === 'stt' ? 'Голос' : 'Текст';
}

export function shouldShowDeleteEncryptedCredential(provider: AiProviderStatus): boolean {
  return provider.source === 'encrypted';
}

export function emptyProviderCredentialForm(): { apiKey: string; folderId: string } {
  return { apiKey: '', folderId: '' };
}

export const PROVIDER_CREDENTIAL_LABELS: Record<string, string> = {
  yandex: 'YandexGPT',
  deepseek: 'DeepSeek',
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  openrouter: 'OpenRouter',
  openai_compatible: 'OpenAI-compatible API',
  remote_runner: 'Remote AI Runner',
  speechkit: 'SpeechKit',
};

export function providerCredentialLabel(providerId: string): string {
  return PROVIDER_CREDENTIAL_LABELS[providerId] ?? providerId;
}

export function providerNeedsFolderId(providerId: string): boolean {
  return providerId === 'yandex' || providerId === 'speechkit';
}
